// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bcac29e9","455":"354b54e1"}[chunkId] + ".chunk.js";
};